import { useState } from "react";
import { useTranslation } from "react-i18next";
import { History } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useDilemmasFormStore } from "../../stores/useDilemmaFormStore";

const DilemmaChangesDialog = () => {
  const { t } = useTranslation();
  const changesHtml = useDilemmasFormStore(
    (s) => s.createdDilemma?.changes_html,
  );
  const [open, setOpen] = useState(false);

  if (!changesHtml) return null;

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="w-full"
        onClick={() => setOpen(true)}
      >
        <History className="size-4" />
        {t("keys.see_changes")}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          showCloseButton={false}
          className="w-[95vw] sm:max-w-[95vw] h-[90vh] flex flex-col"
        >
          <DialogHeader className="flex-row items-center justify-between space-y-0">
            <DialogTitle>
              {t("modules.history.changes_dialog.title")}
            </DialogTitle>
            <DialogClose asChild>
              <Button variant="outline" size="sm">
                {t("modules.history.changes_dialog.close")}
              </Button>
            </DialogClose>
          </DialogHeader>
          <iframe
            className="flex-1 w-full rounded-md border"
            sandbox="allow-same-origin"
            srcDoc={changesHtml}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DilemmaChangesDialog;
